import { formatCurrency } from "@/utils/format-currency";
import { formatLabel } from "@/utils/format-label";
import { Box, Typography } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";

export const getGlLedgerColumns = () => [
  {
    accessorKey: "journalReference",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Journal Reference</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500} fontFamily="monospace">
        {row.original.journalReference ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "valueDate",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Value Date</div>,
    cell: ({ row }) => {
      const date = row.original.valueDate;
      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      const parsed = parseISO(date);
      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A"}
        </div>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date & Time</div>,
    cell: ({ row }) => {
      const date = row.original.createdAt;
      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      const parsed = parseISO(date);
      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isValid(parsed) ? format(parsed, "MMM d, yyyy · HH:mm") : "N/A"}
        </div>
      );
    },
  },
  {
    accessorKey: "narration",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Narration</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", maxWidth: 220 }}>
        {row.original.narration ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "direction",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Direction</div>,
    cell: ({ row }) => {
      const direction = row.original.direction;
      const isCredit = direction === "CREDIT";
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isCredit ? "#ecfdf5" : "#fef2f2",
            color: isCredit ? "#065f46" : "#991b1b",
            fontSize: "0.78rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          {formatLabel(direction)}
        </Box>
      );
    },
  },
  {
    accessorKey: "amount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Amount (₦)</div>,
    cell: ({ row }) => {
      const { amount, direction } = row.original;
      const isCredit = direction === "CREDIT";
      return (
        <Typography
          fontSize="0.85rem"
          fontWeight={500}
          color={isCredit ? "success.main" : "error.main"}
        >
          {amount != null ? formatCurrency(amount) : "—"}
        </Typography>
      );
    },
  },
  {
    accessorKey: "journalEventType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Event Type</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatLabel(row.original.journalEventType) ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "accountName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Account</div>,
    cell: ({ row }) => (
      <div>
        <div
          style={{ fontSize: "0.85rem", fontWeight: 500, whiteSpace: "nowrap" }}
        >
          {row.original.accountName ?? "N/A"}
        </div>
        <div style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 2 }}>
          {row.original.accountCode}
        </div>
      </div>
    ),
  },
  {
    accessorKey: "currency",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Currency</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {row.original.currency ?? "N/A"}
      </div>
    ),
  },
];
